import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const hasModuleTBAI = store.getters['auth/hasTBAIModule']
  const hasModuleXslt = store.getters['auth/hasXsltModule']
  const hasModuleVeriFactu = store.getters['auth/hasVerifactuModule']
  const hasModuleOCRIntegration = store.getters['auth/hasOCRIntegrationModule']
  const hasModuleReceivedInvoice = store.getters['auth/hasReceivedInvoiceModule']

  const reportconfig = {
    name: i18n.t('companies.hacienda_report'),
    path: 'companies/reportconfig',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const pgeconfig = {
    name: i18n.t('companies.configuration_rec.dir_header'),
    path: 'companies/pgeconfig',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const apsconfig = {
    name: i18n.t('companies.configuration_aps.aps_header'),
    path: 'companies/apsconfig',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const configPdftemplate = {
    name: i18n.t('plantilla_pdf.header'),
    path: 'companies/pdftemplate',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const historical = {
    name: i18n.t('historical.entity_name'),
    path: 'companies/historical',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: []
  }

  const companiesMenu = {
    icon: 'companies',
    name: i18n.t('companies.header'),
    path: 'companies',
    use_parent_params: true,
    params_required: ['id'],
    registerNavFromMenu: false,
    sc: [
      {
        name: i18n.t('app.detail'),
        path: 'companies/detail',
        params,
        registerNavFromMenu: false,
        sc: [] // shorcuts
      },
      {
        name: i18n.t('companies.configuration.header'),
        path: 'companies/config',
        params,
        registerNavFromMenu: false,
        disabled: params.id === -1 || params.id === '-1',
        sc: [] // shorcuts
      }
    ]
  }

  if (hasModuleTBAI || hasModuleVeriFactu) {
    companiesMenu.sc.push(reportconfig)
  }
  
  if (hasModuleReceivedInvoice) {
    companiesMenu.sc.push(pgeconfig)
    if (hasModuleOCRIntegration) {
      companiesMenu.sc.push(apsconfig)
    }
  }
  if (hasModuleXslt) {
    companiesMenu.sc.push(configPdftemplate)
  }
  companiesMenu.sc.push(historical)
  return [
    companiesMenu
  ]
}
